// LoginPage.js

import React, { useState } from "react";
import "../components/Styles/LoginPage.css";

function LoginPage() {

  const [isSignup, setIsSignup] = useState(false);

  return (
    <div className="auth-page">

      {/* LEFT SIDE */}

      <div className="auth-left">

        <div className="overlay"></div>

        <div className="left-content">

          <h1>
            Welcome to <span>LegalAxis</span>
          </h1>

          <p>
            Manage your legal services, startup registration,
            trademark filing, agreements and much more in one place.
          </p>

          <div className="feature-list">

            <div className="feature-item">
              ✔ Trusted Legal Experts
            </div>

            <div className="feature-item">
              ✔ 24x7 Support & Consultation
            </div>

            <div className="feature-item">
              ✔ Fast & Secure Process
            </div>

          </div>

        </div>

      </div>

      {/* RIGHT SIDE */}

      <div className="auth-right">

        <div className="auth-box">

          <div className="auth-toggle">

            <button
              className={!isSignup ? "active-btn" : ""}
              onClick={() => setIsSignup(false)}
            >
              Login
            </button>

            <button
              className={isSignup ? "active-btn" : ""}
              onClick={() => setIsSignup(true)}
            >
              Sign Up
            </button>

          </div>

          {
            !isSignup ? (

              <form className="auth-form">

                <h2>Login Your Account</h2>

                <input
                  type="email"
                  placeholder="Enter Email Address"
                />

                <input
                  type="password"
                  placeholder="Enter Password"
                />

                <div className="form-options">

                  <label>
                    <input type="checkbox" />
                    Remember Me
                  </label>

                  <a href="/">
                    Forgot Password?
                  </a>

                </div>

                <button type="submit" className="submit-btn">
                  Login Now
                </button>

                <div className="social-login">

                  <p>Or Login With</p>

                  <div className="social-buttons">

                    <button className="google-btn">
                      Google
                    </button>

                    <button className="facebook-btn">
                      Facebook
                    </button>

                  </div>

                </div>

              </form>

            ) : (

              <form className="auth-form">

                <h2>Create Account</h2>

                <input
                  type="text"
                  placeholder="Full Name"
                />

                <input
                  type="email"
                  placeholder="Email Address"
                />

                <input
                  type="text"
                  placeholder="Phone Number"
                />

                <input
                  type="password"
                  placeholder="Create Password"
                />

                <input
                  type="password"
                  placeholder="Confirm Password"
                />

                <button type="submit" className="submit-btn">
                  Create Account
                </button>

              </form>

            )
          }

        </div>

      </div>

    </div>
  );
}

export default LoginPage;